import { useState } from 'react';

function useForceRefresh() {
  const [timestamp, setTimestamp] = useState<Date>();

  return { timestamp, refresh: () => setTimestamp(new Date()) };
}

export default useForceRefresh;
